import { render, staticRenderFns } from "./EmploymentCard.vue?vue&type=template&id=6ec5ac6e&scoped=true&"
import script from "./EmploymentCard.vue?vue&type=script&lang=ts&"
export * from "./EmploymentCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec5ac6e",
  null
  
)

export default component.exports